import React from 'react';
import { useSelector } from 'react-redux';
import getDesignedProduct from 'store/product/selector/getDesignedProduct';
import BreadcrumbsMobile from 'components/Common/BreadcrumbsMobile/BreadcrumbsMobile';
import Breadcrumbs from 'components/Common/Breadcrumbs/Breadcrumbs';
import isDesktop from 'store/app/selector/isDesktop';

const ProductBreadcrumbs = () => {
  const designName = useSelector(getDesignedProduct)?.content?.designName || undefined;
  const isDesktopDevice = useSelector(isDesktop);
  return isDesktopDevice ? <Breadcrumbs extraCrumb={designName} /> : <BreadcrumbsMobile extraCrumb={designName} />;
};

export default ProductBreadcrumbs;
